(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  exports.Maps = (function(superClass) {
    extend(Maps, superClass);

    function Maps(handler) {
      Maps.__super__.constructor.call(this);
      this.handler = handler;
      this.is_new = ko.observable(true);
      this.is_upload = ko.observable(false);
      this.is_download = ko.observable(false);
      this.is_draw = ko.observable(false);
    }

    Maps.prototype.startUpload = function() {
      this.is_new(false);
      this.is_upload(true);
      return this.is_download(false);
    };

    Maps.prototype.startDownload = function() {
      this.is_new(false);
      this.is_upload(false);
      return this.is_download(true);
    };

    Maps.prototype.startDraw = function() {
      this.is_new(true);
      this.is_upload(false);
      this.is_download(false);
      return this.is_draw(true);
    };

    Maps.prototype.reset = function() {
      this.is_new(true);
      this.is_upload(false);
      this.is_download(false);
      return this.is_draw(false);
    };

    Maps.prototype.launchDrawHandler = function() {
      var DrawHandler;
      DrawHandler = this.handler.parent.createSubHandler("grower::handlers/data/Data_Maps_Draw_Handler");
      if (DrawHandler) {
        return DrawHandler.init();
      }
    };

    return Maps;

  })(KoModel);

}).call(this);
